import React from 'react';
import './Roadmap.css';

function Roadmap() {
  return (
    <section className="page-content roadmap-content">
      
    </section>
  );
}

export default Roadmap;
